var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"site-header"}},[(_vm.isSmartphone)?_c('smartphone-site-header',{attrs:{"smartphoneMenuOpened":_vm.smartphoneMenuOpened},on:{"toggleSmartphoneMenu":function($event){return _vm.$emit('toggleSmartphoneMenu')}}}):_c('desktop-site-header')],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/blocks/SiteHeader.vue?vue&type=template&id=dc7fe0cc&
// module id = 925
// module chunks = 0